import { app } from '@/main';

import { SuperAdminPermission } from '@/models/super-admin';
import AdminKeywordsList from '@/views/Admin/KeywordsList/KeywordsList.vue';

import { Route } from '../route.model';

const validateRouteFlag = () => {
  const permissions = app.$store.getters['manager/getPermissions'];

  return [SuperAdminPermission.KeywordUpdate].some(permission =>
    permissions.includes(permission)
  );
};

const adminKeywordsList = new Route(
  '/admin/keywords',
  'keywords',
  AdminKeywordsList,
  {
    requiresAuth: true,
    superRoot: true,
    navbar: {
      name: 'Keywords'
    },
    zendesk: {
      disabled: true
    },
    customFlagValidator: validateRouteFlag
  }
);

export { adminKeywordsList };
export default adminKeywordsList;
